import script from "./Pagination.vue?vue&type=script&setup=true&lang=js"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=9f1e0c6a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\winkk\\Downloads\\交接\\20261021\\nsr-isso\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f1e0c6a"]])

export default __exports__